export const accountType = {
  Normal: 0,
  Main: 1,
  Sub: 2,
};

export const getAccoutType = () => window.pageProps.multiaccount_type || accountType.Normal;

export const getMainAccountId = () => {
  const type = getAccoutType();

  if (type == accountType.Sub) {
    return window.pageProps.main_account_id || '';
  }

  return '';
};

export const getSubAccountIds = () => {
  const type = getAccoutType();

  if (type == accountType.Main) {
    return window.pageProps.sub_account_ids || [];
  }

  return [];
};

export const isMainAccount = () => {
  const type = getAccoutType();

  return type == accountType.Main;
};

export const isSubAccount = () => {
  const type = getAccoutType();

  return type == accountType.Sub;
};

export const isNormalAccount = () => {
  const type = getAccoutType();

  return type == accountType.Normal;
};

export const bindStatus = {
  'pre-bind': 0, // 待确认授权
  binded: 1,
  reject: 2,
  cancel: 3,
  'bind-overtime': 4,
  canceling: 5,
  canceled: 6,
};
